import React, { Component } from 'react';
import AnimatedNumber from 'react-animated-number';
import glamorous from 'glamorous';
import _ from 'lodash';
import { Button } from 'pp-react';

import * as analytics from '../lib/analytics';

const PromoPanel = glamorous.div(
  {
    height: '350px',
    paddingTop: '30px',
    display: 'table',
    backgroundSize: 'cover',
    position: 'relative',
  },
  ({ backgroundImage }) => ({
    background: `url('${backgroundImage}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center'
  })
);

const PromoArea = glamorous.div({
  display: 'table-cell',
  maxHeight: '250px',
  marginTop: '30px',
  verticalAlign: 'middle',
});

const Action = glamorous.div({
  width: '100%',
  marginTop: '10px',
  textAlign: 'center',
});

export class Promotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
    };
    this.animatedNumber = this.animatedNumber.bind(this);
  }

  handleAnalytics(click) {
    analytics.trackLink(
      click,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  }

  componentDidMount() {
    this.setState({
      mounted: true,
    });
  }

  animatedNumber({ value, duration, initialValue, stepPrecision }) {
    initialValue = initialValue || 0;
    stepPrecision = stepPrecision || 0;
    if (this.state.mounted) {
      return (
        <div style={{ display: 'inline-block' }}>
          <AnimatedNumber
            component='text'
            value={value}
            formatValue={v => (!Number.isNaN(v) ? v.toLocaleString() : '')}
            frameStyle={perc => (perc === 100 ? {} : {})}
            duration={duration}
            initialValue={initialValue}
            stepPrecision={stepPrecision}
          />
        </div>
      );
    }
  }

  render() {
    const actionable =
      _.get(this.props, 'promoModule.buttonReqd', 'no') === 'yes';
    return (
      <PromoPanel
        className={'panel'}
        backgroundImage={this.props.promoModule.imgeUrl}
      >
        <PromoArea>
          {actionable && (
            <Action>
              <a href={this.props.promoModule.btnLinkUrl}>
                <Button
                  onClick={this.handleAnalytics.bind(this, 'promoButton')}
                >
                  {this.props.promoModule.btnText}
                </Button>
              </a>
            </Action>
          )}
        </PromoArea>
      </PromoPanel>
    );
  }
}

export default Promotion;
